import React from 'react';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Enrollment } from './models/Enrollment';
import TopNavActions from './TopNavActions';
import ConfirmExitDialog from './ConfirmExitDialog';

interface ExpectationsAndRequirementsProps {
  enrollment: Enrollment;
  onPageChange: (page: string) => void;
}

const ExpectationsAndRequirements: React.FC<ExpectationsAndRequirementsProps> = ({ onPageChange }) => {
  const [openExitDialog, setOpenExitDialog] = React.useState(false);
  const { t } = useTranslation('enrollment');
  const handleNext = () => {
    onPageChange('eligibility-criteria-languages-view');
  };

  const handleBack = () => {
    onPageChange('back');
  };

  return (
    <React.Fragment>
      <TopNavActions
        onBack={handleBack}
        onExit={() => setOpenExitDialog(true)}
      />
      <ConfirmExitDialog
        open={openExitDialog}
        onClose={() => setOpenExitDialog(false)}
        onExit={() => { window.location.href = '/'; }}
      />

      <Typography variant="h4" component='h1' id="page-heading" tabIndex={-1} >{t("Expectations and requirements")}</Typography>
      <Typography variant="body1" component='h2' sx={{ fontWeight: 600, mt: 2 }}>{t("Eligibility")}</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {t("Before you decide if you want to register for this study, we will ask you a few questions to determine if you are eligible.")}
      </Typography>
      <Typography variant="body1" component='h2' sx={{ fontWeight: 600, mt: 2 }}>{t("Consent")}</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {t("You will then learn about the details of the study and decide if you want to participate.")}
      </Typography>
      <Typography variant="body1" component='h2' sx={{ fontWeight: 600, mt: 2 }}>{t("Voice recording")}</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {t("Your voice will be recorded through different voice and speech tasks.")}
      </Typography>
      <Typography variant="body1" component='h2' sx={{ fontWeight: 600, mt: 2 }}>{t("Forms")}</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {t("You will be asked to complete validated forms and questionnaires.")}
      </Typography>
      <Typography variant="body1" component='h2' sx={{ fontWeight: 600, mt: 2 }}>{t("Health information")}</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {t("Some of your non-identifying health information will be uploaded from your chart.")}
      </Typography>

      <Button variant="contained" onClick={handleNext} style={{ marginTop: 32, marginBottom: 32 }}>
        {t("Next")}
      </Button>
    </React.Fragment>
  );
}

export default ExpectationsAndRequirements;
